import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedComponent } from './shared.component';
import { IonicModule } from '@ionic/angular';
import { NgOtpInputModule } from 'ng-otp-input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SuccessComponent } from './success/success.component';
import { ListFilterPipe } from '../pipes/list-filter.pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { LimitClassPipe } from '../pipes/limit-class.pipe';
import { ViewCmsContentComponent } from './view-cms-content/view-cms-content.component';
import { environment } from 'src/environments/environment';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    NgOtpInputModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbDatepickerModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [
    SharedComponent,
    SuccessComponent,
    LimitClassPipe,
    ListFilterPipe,
    ViewCmsContentComponent
  ],
  entryComponents: [
    SuccessComponent,
    ViewCmsContentComponent
  ],
  exports: [
    SuccessComponent,
    ViewCmsContentComponent
  ],
})
export class SharedModule { }
// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, environment.HOST + '/b2c/einitiative-app/assets/i18n/', '.json');
  // return new TranslateHttpLoader(http);
}
